class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      this.summary.setAttribute('aria-expanded', 'true');
    } else {
      this.animations.forEach((animation) => animation.cancel());
      this.summary.setAttribute('aria-expanded', 'false');
    }
  }

  onKeyDown(event) {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    const focusableItems = [...this.content.querySelectorAll('a[href], button, summary')];

    switch (event.key) {
      case 'Escape':
        if (isOpen) {
          event.preventDefault();
          this.close();
          this.summary.focus();
        }
        break;
      case 'ArrowDown':
        if (isOpen && focusableItems.length) {
          event.preventDefault();
          const currentDown = focusableItems.indexOf(document.activeElement);
          const nextIndex = currentDown < focusableItems.length - 1 ? currentDown + 1 : 0;
          focusableItems[nextIndex].focus();
        }
        break;
      case 'ArrowUp':
        if (isOpen && focusableItems.length) {
          event.preventDefault();
          const currentUp = focusableItems.indexOf(document.activeElement);
          if (currentUp <= 0) {
            this.close();
            this.summary.focus();
          } else {
            focusableItems[currentUp - 1].focus();
          }
        }
        break;
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
